function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Send"
}, /*#__PURE__*/React.createElement("title", null, "VF_Dutch_Icons_3rdWave"), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 141.9L0 0l48.3 141.9L0 283.5l283.5-141.6zm-208.2 9.2l.6-1.9h129.3L49.6 226.8l25.7-75.7zm130.2-16.4H75.9l-.6-1.9-25.6-76 155.8 77.9z",
  id: "Layer_1"
}))));